module.exports = __webpack_public_path__ + "static/media/file-xls.0c3979c1.svg";